import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { gettext, translationPropType } from '@eb/i18n';

import { Icon } from '@eb/eds-icon';
import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';

import { LogoWordmarkBrand } from '@eb/eds-iconography';

import './PageHeader.scss';

const HeaderIcon = ({
    iconType,
    iconColor,
    iconSize,
    bottomSpacing = 'eds-l-mar-bot-6',
    shouldNotModifyIcon,
}) => {
    const classes = classNames(
        bottomSpacing,
        'eds-fx--pop eds-fx--delay-1',
        'eds-bg-color--white',
        'authentication__page-header__icon',
        {
            'authentication__page-header__icon-default': shouldNotModifyIcon,
        },
    );

    const conditionalProps = shouldNotModifyIcon
        ? {}
        : { size: iconSize, color: iconColor };

    return (
        <div className={classes} data-testid="page-header-icon">
            <Icon type={iconType} {...conditionalProps} />
        </div>
    );
};

const HeaderTitle = ({
    headerText,
    usesNewStyles,
    bottomSpacing = 'eds-l-mar-bot-10',
    headerClassName = '',
}) => {
    let headerClasses = classNames({
        'eds-text-hl': usesNewStyles,
        'eds-text-hm': !usesNewStyles,
        [bottomSpacing]: !usesNewStyles,
    });

    if (headerClassName != '') {
        headerClasses = headerClassName;
    }

    return (
        <h1 className={headerClasses} data-testid="page-header-title">
            {headerText}
        </h1>
    );
};

const HeaderSubTitle = ({
    subtitleText,
    usesNewStyles,
    bottomSpacing = 'eds-l-mar-bot-8',
}) => {
    let component = null;

    if (subtitleText) {
        const headerSubTitleClasses = classNames(
            'eds-text-color--grey-600',
            'eds-text-bm',
            {
                'eds-l-mar-hor-3': !usesNewStyles,
                'eds-l-pad-top-2': usesNewStyles,
                [bottomSpacing]: !usesNewStyles,
            },
        );

        component = (
            <div
                className={headerSubTitleClasses}
                data-testid="page-header-subtitle"
            >
                {subtitleText}
            </div>
        );
    }

    return component;
};

export default class PageHeader extends React.PureComponent {
    static propTypes = {
        headerText: translationPropType.isRequired,
        iconType: ICON_TYPE_PROP_TYPE,
        subtitleText: PropTypes.any,
        iconColor: PropTypes.string,
        picture: PropTypes.string,
        bottomSpacing: PropTypes.string,
        shouldNotModifyIcon: PropTypes.bool,
        handleTrackBrandLogoClick: PropTypes.func,
    };

    static defaultProps = {
        iconColor: 'ui-orange',
        iconSize: 'medium',
    };

    render() {
        const {
            headerText,
            subtitleText,
            iconColor,
            iconSize,
            iconType,
            picture,
            usesNewStyles,
            bottomSpacing,
            headerClassName,
            shouldNotModifyIcon,
            handleTrackBrandLogoClick,
        } = this.props;
        let icon = null;
        const iconProps = {
            iconColor,
            iconSize,
            bottomSpacing,
            shouldNotModifyIcon,
        };

        if (usesNewStyles && !iconType) {
            icon = (
                <a
                    onClick={
                        handleTrackBrandLogoClick
                            ? handleTrackBrandLogoClick
                            : null
                    }
                    href="/"
                    rel="noopener noreferrer"
                    title={gettext('Go to homepage')}
                >
                    <HeaderIcon
                        iconType={<LogoWordmarkBrand />}
                        {...iconProps}
                    />
                </a>
            );
        }

        if (iconType) {
            icon = <HeaderIcon iconType={iconType} {...iconProps} />;
        }

        if (picture) {
            icon = (
                <img
                    className="authentication__page-header__picture"
                    src={picture}
                    alt={picture}
                />
            );
        }

        const pageHeaderClasses = classNames({
            'authentication__page-header eds-text--center': !usesNewStyles,
            'authentication__page-header--new eds-text--left eds-l-mar-bot-10': usesNewStyles,
        });

        return (
            <div className={pageHeaderClasses}>
                {icon}

                <HeaderTitle
                    headerText={headerText}
                    subtitleText={subtitleText}
                    usesNewStyles={usesNewStyles}
                    bottomSpacing={bottomSpacing}
                    headerClassName={headerClassName}
                />
                <HeaderSubTitle
                    subtitleText={subtitleText}
                    usesNewStyles={usesNewStyles}
                    bottomSpacing={bottomSpacing}
                />
            </div>
        );
    }
}
